import { Link, Navigate } from "react-router-dom";
import constants from "../constants.json";
import { useUser } from "../context/UserContext";
import "./home.css";

const coFounders = [
    {
        name: "David Bradham",
        title: "Co-founder",
        focus: "Property management software and operations workflows"
    },
    {
        name: "Ibrahim Yaro",
        title: "Co-founder",
        focus: "Revenue optimization and owner success"
    }
];

const Home = () => {
    const { user } = useUser();

    if (user?.token) {
        if (String(user.role || '').toLowerCase() === 'cleaner') {
            return <Navigate to="/CleanerDashboard" replace />;
        }
        if (user.role === 'guest') {
            return <Navigate to="/listings" replace />;
        }
        return <Navigate to="/Properties" replace />;
    }

    return (
        <div className="home-page">
            <section className="home-hero">
                <p className="home-kicker">Property Intelligence Platform</p>
                <h1>{constants.name}</h1>
                <p className="home-lead">
                    We help short-term rental operators maximize revenue, control expenses, and make faster decisions with clear property-level reporting.
                </p>
                {!user && (
                    <div className="home-actions">
                        <Link to="/signup" className="home-btn home-btn-primary">Create Account</Link>
                        <Link to="/login" className="home-btn home-btn-secondary">Log In</Link>
                    </div>
                )}
            </section>

            <section className="home-section">
                <h2>Business Goals</h2>
                <div className="home-goals-grid">
                    <article className="home-goal-card">
                        <h3>Grow Net Profit</h3>
                        <p>Track bookings, monthly P&L, and investment impact so every property improves its bottom line.</p>
                    </article>
                    <article className="home-goal-card">
                        <h3>Reduce Waste</h3>
                        <p>Standardize utility and operational costs to quickly catch overspending before it scales.</p>
                    </article>
                    <article className="home-goal-card">
                        <h3>Scale With Confidence</h3>
                        <p>Build repeatable playbooks for onboarding properties, managing cleaners, and monitoring performance.</p>
                    </article>
                </div>
            </section>

            <section className="home-section">
                <h2>Built by Co-founders Focused on Operators</h2>
                <div className="home-founders-grid">
                    {coFounders.map((member) => (
                        <article key={member.name} className="home-founder-card">
                            <h3>{member.name}</h3>
                            <p className="home-founder-title">{member.title}</p>
                            <p>{member.focus}</p>
                        </article>
                    ))}
                </div>
            </section>

            <section className="home-section home-section-consulting">
                <div className="home-section-heading-row">
                    <div>
                        <h2>Consulting For Owners Getting Started</h2>
                        <p className="home-section-intro">
                            Beyond software, we can help new operators build the right foundation before their portfolio grows.
                        </p>
                    </div>
                </div>
                <div className="home-goals-grid">
                    <article className="home-goal-card">
                        <h3>Market Entry Guidance</h3>
                        <p>Get practical advice on launch planning, operational setup, and how to avoid expensive early mistakes.</p>
                    </article>
                    <article className="home-goal-card">
                        <h3>Process Design</h3>
                        <p>We help define playbooks for cleaners, guest communication, revenue reviews, and compliance tracking.</p>
                    </article>
                    <article className="home-goal-card">
                        <h3>Operator Coaching</h3>
                        <p>For owners new to short-term rentals, we can act as a strategic thought partner while systems are still taking shape.</p>
                    </article>
                </div>
            </section>
        </div>
    );
};

export default Home;